import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'

import { defaultPaging } from 'clickNgo/configs/crud'
import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { I577Form } from 'clickNgo/models/crud/forms/i577Form'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderSort, Logic, Operator } from 'core-components/types'
import { toServerFormat } from 'core/classes/helpers/DateHelper'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapPartnerFlagFrom577Crud } from './mapping'

interface IFetchPartnerFlagsByIdAndTypeParams {
  partnerId: string
  type?: ProfilingCodeType
}

export const fetchPartnerFlagsByIdAndType = (
  { partnerId, type }: IFetchPartnerFlagsByIdAndTypeParams,
  options?: ICrudFetchOptions
): Promise<IPartnerFlag[]> => {
  const crud = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags, options?.cacheKey)
  const sortBy: IDataProviderSort = { field: 'Code', dir: 'asc' }
  const paging = options?.paging || defaultPaging

  const filterByPartnerId = {
    field: 'PARTNER_ID',
    operator: Operator.EQUAL,
    value: partnerId,
  }

  const filterByType = {
    field: 'CodeType',
    operator: Operator.EQUAL,
    value: type || '',
  }

  const endDate = new Date()
  endDate.setMinutes(0)
  endDate.setSeconds(0)
  endDate.setMilliseconds(0)

  const filterByDate = {
    field: 'END_DATE',
    operator: Operator.GTE,
    value: toServerFormat(endDate),
  }

  const filters = type
    ? [filterByPartnerId, filterByType, filterByDate]
    : [filterByPartnerId, filterByDate]

  const defaultFilter = {
    logic: Logic.AND,
    filters,
  }

  crud.setFilter(defaultFilter)
  crud.setSort(sortBy)
  crud.setPaging(paging)

  if (options?.isForce) {
    crud.removeQueries(true)
  }

  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result: { items: I577Form[] }) => {
      if (result && result.items) {
        return result.items.map(mapPartnerFlagFrom577Crud)
      }

      return []
    })
    .catch((e: string) => {
      Logger.error(e)
      return []
    })
}
